<template>
  <div>
    <v-btn v-if="params.data?.inscripcion?.montos" class="mb-2" x-small outlined @click="abrirModal">
      {{ montoTotalPagado }}

      <span v-if="tieneAlgunPagoRegularizado || tieneAlgunPagoCompensado" class="red--text font-weight-bold"> * </span>

      <v-icon small>mdi-information-outline</v-icon>
    </v-btn>

    <span v-else>-</span>

    <ModalDetallesMontos ref="modalDetallesMontosRef" :montos="params.data?.inscripcion?.montos" />
  </div>
</template>

<script>
import { formatearValorAMoneda } from '../utils/funciones';
import botonMontoTotalConceptosMixin from './../mixins/boton-monto-total-conceptos.mixin';

export default {
  name: 'BotonMontoTotalConceptos2',
  mixins: [botonMontoTotalConceptosMixin],
  computed: {
    tieneAlgunPagoRegularizado() {
      if (!this.params.data?.inscripcion?.montos) {
        return false;
      }

      const montos = this.params.data?.inscripcion?.montos;

      return (
        Number(montos?.regularizadoMatricula) > 0 ||
        Number(montos?.regularizadoColegiatura) > 0 ||
        Number(montos?.regularizadoCertificacion) > 0
      );
    },
    tieneAlgunPagoCompensado() {
      if (!this.params.data?.inscripcion?.montos) {
        return false;
      }

      const montos = this.params.data?.inscripcion?.montos;

      return (
        Number(montos?.compensacionMatricula) > 0 ||
        Number(montos?.compensacionColegiatura) > 0 ||
        Number(montos?.compensacionCertificacion) > 0
      );
    },
    montoTotalPagado() {
      if (!this.params.data?.inscripcion?.montos) {
        return '-';
      }

      return formatearValorAMoneda(
        Number(this.params.data?.inscripcion?.montos?.pagoMatricula) +
          Number(this.params.data?.inscripcion?.montos?.pagoColegiatura) +
          Number(this.params.data?.inscripcion?.montos?.pagoCertificacion),
      );
    },
  },
};
</script>
